import { planTypes } from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';
import { mapGetters } from 'vuex';
import { planUnitMap } from '@/common/product-unit';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';

export default {
  key: planTypes[planTypes.ZOOM_CLIPS],
  data() {
    return {
      title: this.$t('billing.zoom_clips_plus.title'),
      subtitle: '',
      planType: planTypes.ZOOM_CLIPS,
      logo: getPlanLogo(planTypes.ZOOM_CLIPS),
      description: this.$t('billing.zoom_clips_plus.desc'),
      unit: planUnitMap.user,
      trackingPlanName: getTrackingProductNameByPlanType(planTypes.ZOOM_CLIPS),
    }
  },
  computed: {
    ...mapGetters(['getTypeGroupSelectedPlans']),
    trackingPlanKey() {
      return this.trackingPlanName
    },
    selectedPlan() {
      return this.getTypeGroupSelectedPlans[this.planType]?.[0];
    },
  },
};
